import { z } from 'zod/v3';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './SampleValidFormDataSchema.translations.json';

const { addTranslations, t } = i18nNsFactory('sample-valid-form-data-schema');
addTranslations(translations);

export const SampleDataObjectValidFormDataSchema = z.object({
  id: z.number().optional(),
  isLocked: z.boolean(),
  hasActive: z.boolean(),
  dataObjectDescriptionId: z.number(),
  comments: z.string(),
});

export const SampleDataSubjectValidFormDataSchema = z.object({
  id: z.number().optional(),
  dataSubject: z.object({
    id: z
      .number({
        errorMap: () => ({
          message: t('validation.samples.dataSubject.required'),
        }),
      })
      .min(1),
    name: z.custom<`${string} - ${string}`>(),
  }),
  comments: z.string(),
  isLocked: z.boolean(),
  sampleDataObjects: SampleDataObjectValidFormDataSchema.array(),
});

export const SampleValidFormDataSchema = z.object({
  samples: SampleDataSubjectValidFormDataSchema.array(),
});
